'use strict';

var toastr = require('toastr');
var HepSimpleService = function HepSimpleService(App, $log, $q, restangular, momentService) {
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('HepService: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
    return $q.reject();
  }
  function saveSimpleHepProperties(simpleHepProperties, simpleHepCategory) {
    var simpleHepConfig = {
      eventTimeStamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toISOString(),
      type: simpleHepCategory,
      properties: simpleHepProperties
    };
    return restangular.one('configuration').one('hepSimple').customPUT(simpleHepConfig).then(function () {
      App.hep = simpleHepProperties;
      postColumnsSuccessHandler.apply(null, arguments);
    }, postColumnsErrorHandler);
  }
  return {
    saveSimpleHepProperties: saveSimpleHepProperties
  };
};
HepSimpleService.$inject = ['App', '$log', '$q', 'Restangular', 'MomentService'];
module.exports = HepSimpleService;